module.exports = __webpack_public_path__ + "fonts/montserrat-thin-webfont.2509b26.woff";